import React, { useState } from 'react';
import { Button, Flex } from '@chakra-ui/react';
import { InputField } from './InputField';
import { useField } from 'formik';
import { http } from '@/lib/ats-https';
import { useShowToast } from '@/hooks';

interface InputWithGenerateProps {
  item?: Record<string, unknown>;
  field: any;
  formik?: any;
}

export const InputWithGenerate = ({
  item = {},
  field,
  formik,
}: InputWithGenerateProps) => {
  const {
    generateText = 'Generate',
    name,
    label,
    disabled,
    apiConfig = {},
    loadingText = 'Generating',
    generateButtonStyles = {},
  } = item as any;
  const { method = 'get', endpoint, processVal = () => {} } = apiConfig;
  const [isLoading, setIsLoading] = useState(false);
  const toast = useShowToast();

  const [, { value }, helpers] = useField(name);
  const { setValue } = helpers;

  const handleGenerateClick = async () => {
    setIsLoading(true);
    try {
      const result = await http[method](`${endpoint}`);
      const newValue = await processVal(result);
      if (newValue) {
        setValue(newValue);
      } else {
        toast({
          title: `Error in getting ${label}`,
          description: '',
          status: 'error',
        });
      }
    } catch (error) {
      toast({
        title: `Error in getting ${label}`,
        description: error?.message,
        status: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderGenerateButton = () => {
    if (disabled || value) {
      return null;
    }

    return (
      <Button
        cursor="pointer"
        color="ats-primary"
        onClick={handleGenerateClick}
        minW="max-content"
        background="none"
        isLoading={isLoading}
        loadingText={loadingText}
        _hover={{
          textDecoration: 'underline',
          textDecorationThickness: '2px',
        }}
        {...generateButtonStyles}
      >
        {generateText}
      </Button>
    );
  };

  return (
    <Flex gap="10px" alignItems="center" w="60%">
      <InputField item={item} field={field} formik={formik} />
      {renderGenerateButton()}
    </Flex>
  );
};
